module.exports = __webpack_public_path__ + "img/20200717_172124.2a0e94dd.jpg";